import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ApplicationUserViewModel } from '../../models';

class WtApplicationUsersMultiSelectController implements angular.IComponentController {
    formController: angular.IFormController;
    model: string[];
    users: ApplicationUserViewModel[];

    static $inject = [];

    drop(data: { itemId: string }): void {
        const userId = data.itemId.replace('id', '');
        if (_.some(this.users, u => u.userId === userId) && _.every(this.model, u => u !== userId)) {
            this.model.push(userId);
            this.formController.$setDirty();
        }
    }
}

export const wtApplicationUsersMultiSelect: ComponentDefinition = {
    componentId: 'wtApplicationUsersMultiSelect',
    template: require('./applicationUsersMultiSelect.component.html'),
    controller: WtApplicationUsersMultiSelectController,
    controllerAs: 'vm',
    bindings: {
        model: '=',
        isEditMode: '=',
        users: '=',
        formController: '='
    }
};
